import Vue from 'vue';

import VueCircleSlider from 'vue-circle-slider';
var VueScrollTo = require('vue-scrollto');

Vue.use(VueCircleSlider);
Vue.use(VueScrollTo, {
  container: '#app',
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

// used to Support contentComponent.nextDisabled reading on Stap.vue
import { DynamicReactiveRefs } from 'vue-reactive-refs';
Vue.use(DynamicReactiveRefs);

import device from 'vue-device-detector';
Vue.use(device);

import AsyncComputed from 'vue-async-computed';
Vue.use(AsyncComputed);
